import { BrowserRouter, Routes, Route, useLocation as useRouterLocation } from "react-router-dom";
import "@/App.css";
import "leaflet/dist/leaflet.css";

// Context
import { LanguageProvider } from "./context/LanguageContext";
import { LocationProvider, useLocation } from "./context/LocationContext";

// Layout components
import { TopNav } from "./components/layout/TopNav";
import { MobileNav } from "./components/layout/MobileNav";
import { CookieConsent } from "./components/CookieConsent";
import { EmergencyFloatingButton } from "./components/EmergencyFloatingButton";

// Pages
import OnboardingScreen from "./pages/OnboardingScreen";
import HomePage from "./pages/HomePage";
import ConciergePage from "./pages/ConciergePage";
import BeachesPage from "./pages/BeachesPage";
import ParkingPage from "./pages/ParkingPage";
import RestaurantsPage from "./pages/RestaurantsPage";
import EventsPage from "./pages/EventsPage";
import UpsellsPage from "./pages/UpsellsPage";
import EmergencyPage from "./pages/EmergencyPage";
import HostLoginPage from "./pages/HostLoginPage";
import HostDashboardPage from "./pages/HostDashboardPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SharedItineraryPage from "./pages/SharedItineraryPage";
import CulturalGuidePage from "./pages/CulturalGuidePage";
import OfflineMapsPage from "./pages/OfflineMapsPage";

// Hook to check if we should show the floating emergency button
function EmergencyButtonWrapper() {
  const routerLocation = useRouterLocation();
  // Don't show on emergency page itself
  if (routerLocation.pathname === '/emergency') return null;
  return <EmergencyFloatingButton />;
}

function AppContent() {
  const { isOnboarded } = useLocation();

  return (
    <Routes>
      {/* Shared itinerary page - accessible without onboarding */}
      <Route path="/shared/:shareId" element={<SharedItineraryPage />} />
      
      {/* All other routes require onboarding */}
      <Route path="/*" element={
        isOnboarded ? (
          <>
            <TopNav />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/concierge" element={<ConciergePage />} />
              <Route path="/beaches" element={<BeachesPage />} />
              <Route path="/parking" element={<ParkingPage />} />
              <Route path="/restaurants" element={<RestaurantsPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/upsells" element={<UpsellsPage />} />
              <Route path="/emergency" element={<EmergencyPage />} />
              <Route path="/host-login" element={<HostLoginPage />} />
              <Route path="/host-dashboard" element={<HostDashboardPage />} />
              <Route path="/booking-success" element={<BookingSuccessPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/cultural-guide" element={<CulturalGuidePage />} />
              <Route path="/offline-maps" element={<OfflineMapsPage />} />
            </Routes>
            <MobileNav />
            <EmergencyButtonWrapper />
            <CookieConsent />
          </>
        ) : (
          <OnboardingScreen />
        )
      } />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <LocationProvider>
        <div className="App font-sans antialiased">
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </div>
      </LocationProvider>
    </LanguageProvider>
  );
}

export default App;
